import { WorkflowSidebar } from '@salecycle/ui-component-library';
import { DisplayWebContentButton } from '../Workflows/DisplayWebContent/DisplayWebContentButton';
import { SendEmailButton } from '../Workflows/SendEmail/SendEmailButton';
import styled from 'styled-components';
import { BranchControlsButton } from '../Workflows/BranchControl/BranchControlsButton';
import { useTranslation } from 'react-i18next';

const WorkflowContainer = styled.aside`
  width: 400px;
  height: 100%;
  position: absolute;
  padding: 40px;
  background-color: ${({ theme }) => theme.designToken.neutral50};

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing5};
`;

export function Sidebar() {
  const { t } = useTranslation('campaigns');
  return (
    <WorkflowContainer>
      <div>{t('onsite.editor.workflow.dragMessageSidebar')}</div>
      <div>
        <WorkflowSidebar
          header={t('onsite.editor.workflow.sideBar.heading.messages')}
          tooltip={t('onsite.editor.workflow.sideBar.tooltip.messages')}
        >
          <DisplayWebContentButton />
          <SendEmailButton />
        </WorkflowSidebar>
      </div>
      <div>
        <WorkflowSidebar
          header={t('onsite.editor.workflow.sideBar.heading.actions')}
          tooltip={t('onsite.editor.workflow.sideBar.tooltip.actions')}
        >
          <BranchControlsButton />
        </WorkflowSidebar>
      </div>
    </WorkflowContainer>
  );
}
